<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import { useStudentStore } from '@/stores/student'
import iconNinja from '@images/icon-ninja.svg'
import iconTrial from '@images/icon-trial.svg'
import { useI18n } from 'vue-i18n'
import { useDisplay } from 'vuetify'

const { t } = useI18n()
const { smAndDown } = useDisplay()
const authStore = useAuthStore()
const studentStore = useStudentStore()

const showBar = computed(() => studentStore.is_trial || authStore.is_shadowing)

const barText = computed(() => {
  if (authStore.is_shadowing) {
    return t('pages.non_standard_student.shadowing_bar', { studentName: studentStore.full_name })
  }
  return t('pages.non_standard_student.trial_bar')
})

const barIcon = computed(() =>
  authStore.is_shadowing ? iconNinja : iconTrial
)
</script>

<template>
  <div
    v-if="showBar"
    :class="[
      'non-standard-student-bar',
      {
        'non-standard-student-bar--shadowing': authStore.is_shadowing,
        'non-standard-student-bar__smaller': smAndDown
      }
    ]"
  >
    <img
      :src="barIcon"
      class="non-standard-student-bar__icon"
    />
    {{ barText }}
  </div>
</template>

<style lang="scss" scoped>
.non-standard-student-bar {
  align-items: center;
  background-color: rgba(var(--v-theme-trial), 0.85) !important;
  bottom: 0;
  color: white;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  position: fixed;
  width: 100%;
  z-index: 10000;

  &__icon {
    display: block;
    height: 1.2rem;
  }

  &--shadowing {
    background-color: rgba(var(--v-theme-grey-800), 0.9) !important;
  }

  &__smaller {
    bottom: 4.5rem !important;
  }
}
</style>
